export default __webpack_public_path__ + "images/GQ.baa21f2.png";